import { Injectable } from '@angular/core';
import { ApiHttpService } from '../../../shared/services/api_http.service';
import { Observable } from 'rxjs';

@Injectable()
export class ReminderService {
  constructor(private http: ApiHttpService) {
  }

  get(): Observable<any> {
    return this.http.get('apps/:app_key/reminders');
  }

  update(reminder: any): Observable<any> {
    return this.http.put(`apps/:app_key/reminders/${reminder.id}`, reminder);
  }

  delete(reminder: any): Observable<any> {
    return this.http.delete(`apps/:app_key/reminders/${reminder.id}`);
  }

  create(reminder: any): Observable<any> {
    return this.http.post('apps/:app_key/reminders', reminder);
  }

}
